import React, { Fragment, useEffect, useState } from "react";
import {Link, useLocation, useParams} from "react-router-dom";
import '../../assets/cssnew/Single_product.css';
import axios from "axios";
import clientconfigwebapp, {
    check_login_appbk,
    empty_bk,
    Token_get_appbk,
    seo_setmetabk,
} from "../../clientconfigwebapp";
import { toast, ToastContainer } from "react-toastify";
import Grid from '@mui/material/Grid';
import Master_Front from "../../pages/Master_Front";

import {
    Icon_User,
    Icon_Location,
    Icon_inventory,
    Icon_Insurance,
    Icon_Packaging_and_label,
    Icon_Quality_Control,
    Icon_Transportation,
    Icon_Customs_formalities,
    Icon_singpro_Authenticated, Icon_btn_tiket_singprod, Icon_btn_call_singprod,
} from "../../assets/icones/icones_single_products";

import Sticky from 'react-stickynode';

import Section_1 from "./Parts/Section_1";
import Section_2 from "./Parts/Section_2";
import Section_3 from "./Parts/Section_3";
import ReactFullPageLoadinghk from "../../components/layaout/LoadingFullpagehk";


const Single_product = (props) => {
    const location_get_urlbk = useLocation();
    const [wallet_balance, setData_wallet_balance] = useState('0');
    const [first_name_profile, setData_first_name_profile] = useState('');
    const [last_name_profile, setData_last_name_profile] = useState('');
    const { post_id } = useParams();
    const [data_slider_list, set_data_slider_list] = useState([]);
    const [data_paged_info, set_data_paged_info] = useState([]);
    const [products_seller_curent, set_data_products_seller_curent] = useState([]);
    const [posts_products_curent_cat, set_data_posts_products_curent_cat] = useState([]);


    const [post_cat_step_end, set_post_cat_step_end] = useState([]);

    const [loadinghkfullshow, Setloadinghkfullshow] = useState("false");






    useEffect(() => {
        Load_api_page();
    }, [location_get_urlbk]);

    const Load_api_page = () => {
        let config = null;
        if (check_login_appbk() === true) {
            config = {
                headers: { Authorization: `Bearer ${Token_get_appbk()}` }
            };
        }

        Setloadinghkfullshow("true");

        set_data_paged_info([]);
        set_data_products_seller_curent([]);
        set_data_posts_products_curent_cat([]);

        let post_get_user = "";
        if (!empty_bk(post_id)) {
            post_get_user = String(post_id);
        }

        const data_form = { post_id: String(post_get_user) };

        axios.post(`${clientconfigwebapp.siteurl}api/v1/single-product/`, data_form, config)
            .then((res) => {

                if (String(res.data.data).length > 0) {
                    if (String(res.data.wallet_inventory).length > 0) {
                        setData_wallet_balance(res.data.wallet_inventory);
                    }
                    if (!empty_bk(res.data.first_name_profile)) {
                        setData_first_name_profile(res.data.first_name_profile);
                        localStorage.setItem('first_name_Get', res.data.first_name_profile);
                    }
                    if (!empty_bk(res.data.last_name_profile)) {
                        setData_last_name_profile(res.data.last_name_profile);
                        localStorage.setItem('last_name_Get', res.data.last_name_profile);
                    }

                    if (String(res.data.data).length > 0) {
                        set_data_paged_info(res.data.data);
                    } else {
                        set_data_paged_info([]);
                    }

                    if (String(res.data.data.post_gallery).length > 0) {
                        set_data_slider_list(res.data.data.post_gallery);
                    } else {
                        set_data_slider_list([]);
                    }


                    if (String(res.data.products_seller_curent).length > 0) {
                        set_data_products_seller_curent(res.data.products_seller_curent);
                    } else {
                        set_data_products_seller_curent([]);
                    }



                    if (String(res.data.posts_products_curent_cat).length > 0) {
                        set_data_posts_products_curent_cat(res.data.posts_products_curent_cat);
                    } else {
                        set_data_posts_products_curent_cat([]);
                    }

                    if (String(res.data.post_cat_step_end).length > 0) {
                        set_post_cat_step_end(res.data.post_cat_step_end);
                        console.log(res.data.post_cat_step_end,"post_cat_step_end")
                    } else {
                        set_post_cat_step_end([]);
                    }


                    const dataItem = res?.data?.data?.[0];

                    if (dataItem) {
                        const title = (typeof dataItem.meta_title_seo === 'string' && dataItem.meta_title_seo.trim().length > 0)
                            ? dataItem.meta_title_seo
                            : dataItem.title_cat;

                        const metaDescription = (typeof dataItem.meta_descr_seo === 'string' && dataItem.meta_descr_seo.trim().length > 0)
                            ? dataItem.meta_descr_seo
                            : dataItem.title_cat;

                        seo_setmetabk({
                            title,
                            metaDescription,
                        });
                    }




                    Setloadinghkfullshow("false");



                } else {
                    Setloadinghkfullshow("false");
                    if (String(res.data.msgwebapp).length > 0) toast.error(res.data.msgwebapp, {
                        position: "top-center",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }
            }).catch((err) => {
            Setloadinghkfullshow("false");
            toast.error('خطای اتصال به سرور کد 435345', {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        });
    }

    return (
        <Fragment>

            <Master_Front wallet_balance={wallet_balance} first_name_profile={first_name_profile}
                          last_name_profile={last_name_profile}>

                <ToastContainer/>

                <ReactFullPageLoadinghk loadinghk={loadinghkfullshow}/>


                <div className={"text-center content-center justify-start"}
                     style={{"display": "flex", "marginBottom": "5px"}}>
                    <Link className={"text-[13px]"} to={"/"}>صفحه اصلی</Link>

                    {
                        data_paged_info  && post_cat_step_end   ? (
                            <Fragment>
                    / <Link  to={`/product-category/${post_cat_step_end.slug}`} className={"pr-[10px] text-[13px]"} style={{"color": "#969fa2"}}>{post_cat_step_end.title_cat}</Link>
                            </Fragment>
                        ):
                            <Fragment>
                     / <span className={"pr-[10px] text-[13px]"} style={{"color": "#969fa2"}}> محصولات </span>
                            </Fragment>
                    }

                </div>

                <Section_1 data_paged_info={data_paged_info} data_slider_list={data_slider_list}/>


                <Section_2 products_seller_curent={products_seller_curent} data_paged_info={data_paged_info}
                           data_slider_list={data_slider_list}/>


                <Section_3 posts_products_curent_cat={posts_products_curent_cat} data_paged_info={data_paged_info}
                           data_slider_list={data_slider_list}/>


            </Master_Front>
        </Fragment>
    );
}

export default Single_product;
